module.exports = __webpack_public_path__ + "static/img/diy-tool-d.60f111d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-tool-d.gif
// module id = BSzm
// module chunks = 0